import React from 'react'
import Breadcrum from '../../components/Breadcrum'

const AboutusComponent = ({ title }) => {
    return (
        <>


            <section className="as_about_wrapper as_padderBottom80">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12 col-md-12 text-center">
                            <h1 className="as_heading as_heading_center">
                                About Astrology
                            </h1>
                            <span>
                            </span>
                            <p className="as_font14 as_padderTop20 ">
                                At Astroscope, we bring the ancient wisdom of astrology into your daily life—right at your fingertips. Whether you're looking for guidance, clarity, or just a deeper connection with the stars, we help you discover what the universe has in store for you.
                            </p>
                        </div>
                        <div className="col-lg-5 col-md-5">
                            <div className="as_aboutimg text-right position-relative">
                                <div className="video-container">
                                    <iframe
                                        src="https://www.youtube.com/embed/xySfvsY2eiw"
                                        title="Astrology Video"
                                        frameBorder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
                                        allowFullScreen
                                        style={{ width: '100%', height: '315px', borderRadius: '10px' }}
                                    ></iframe>
                                    <img
                                        src={`${process.env.PUBLIC_URL}/assets/images/astroscop.png`}
                                        alt="Astroscope Logo"
                                        className="video-logo-overlay"
                                    />
                                </div>
                            </div>
                        </div>
                        <div className="col-lg-7 col-md-7">
                            <div className="as_about_detail">
                                <div className="as_paragraph_wrapper">
                                    <p className="as_font14">
                                        🔮 Daily Horoscopes – Get accurate, personalized horoscopes based on your zodiac sign.<br></br>
                                        📅 Astrology Calendars – Know the best days for love, career, and self-care with our planetary insights.<br></br>
                                        🌌 Birth Chart Readings – Explore your unique cosmic blueprint with detailed natal chart analysis.<br></br>
                                        💫 Compatibility & Love Matching – Find harmony in your relationships through zodiac compatibility.<br></br>
                                        🌠 Live Astrologer Consultations – Talk to expert astrologers for real-time answers and spiritual guidance.<br></br>
                                        📲 Notifications from the Stars – Timely alerts when important planetary shifts happen.
                                    </p>
                                    <p className="as_font14">
                                        We blend traditional Vedic and Western astrology with modern technology to offer a soulful and smart astrological experience. Astroscope is not just about predictions—it's about self-awareness, timing, and empowerment.
                                    </p>
                                </div>
                                <div className="as_contact_expert">
                                    <span className="as_icon">
                                        <img alt="" src="assets/images/svg/about.svg" />
                                    </span>
                                    <span className="as_year_ex">
                                        30
                                    </span>
                                    <div>
                                        <h5>
                                            years of
                                        </h5>
                                        <h1>
                                            Experience
                                        </h1>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default AboutusComponent
